import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    taxAgentName,
    taxAgentId,
    taxCalculationPeriodEnd,
    settlementCase,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [taxAgentId.name]: "",
  [taxCalculationPeriodEnd.name]: "",
  [settlementCase.name]: "",
};

export default initialValues;
